import React, { Component } from "react"
import { withRouter } from "react-router-dom"
import Layout from "../../Layout"
import { ProrrogacaoContratualForm } from "../../modais"

class ProrrogacaoContratualCreateForm extends Component {
  constructor() {
    super()
    this.onSuccess = this.onSuccess.bind(this)
  }
  onSuccess() {
    this.props.history.push("/prorrogacaocontratual")
  }
  render() {
    return (
      <Layout tabActive="Fiscalização">
        <ProrrogacaoContratualForm callBackAtaReuniao={this.onSuccess} />
      </Layout>
    )
  }
}
export default withRouter(ProrrogacaoContratualCreateForm)



// WEBPACK FOOTER //
// ./src/views/fiscalizacao/prorrogacao-contratual/ProrrogacaoContratualCreateForm.js